import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import heroBackground from "../../Assets/hero-image.jpg";
import heroicon from "../../Assets/heroicon.svg";
import { COLORS } from "../../Constants/colors";
import { H1, Highlight } from "../../Constants/typography";

// Outer container
const SectionWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 85vh;
  overflow: hidden;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 12% 20px 40px;
  text-align: center;
  box-sizing: border-box;

  @media screen and (max-width: 768px) {
    height: 70vh;
    padding: 24px 16px;
  }
`;

// Gradient overlay on top of image
const GradientOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: -1;
  background: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0));
`;

// Lazy loaded background image
const BackgroundImage = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top center;
  z-index: -2;
`;

// Animated heading
const AnimatedHeading = styled(H1).attrs({
  as: motion.h1,
})`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: ${COLORS.buttonText};
`;

// Text + icon
const AnimatedTextWithImage = styled.span.attrs({
  as: motion.span,
})`
  margin-top: 12px;
  color: ${COLORS.primary};
  font-weight: 600;
  font-size: 3rem;

  img {
    width: 42px;
    height: 42px;
    margin-right: 10px;
  }

  display: flex;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 768px) {
    img {
      width: 28px;
      height: 28px;
    }
    font-size: 2rem;
  }
`;

// Framer Motion animations
const fadeInHeading = {
  hidden: { opacity: 0, y: -40 },
  visible: { opacity: 1, y: 0, transition: { duration: 2, delay: 0.05 } },
};

const fadeInText = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 2, delay: 0.05 } },
};

const HeroSection = () => {
  return (
    <SectionWrapper>
      <GradientOverlay />
      <BackgroundImage src={heroBackground} alt="Hero background"/>

      <div>
        <AnimatedHeading
          variants={fadeInHeading}
          initial="hidden"
          animate="visible"
          transition={{ delay: 0.3 }}
        >
          <div>
            Empowering our {typeof window !== "undefined" && window.innerWidth <= 768 && <br />}
            <Highlight style={{ color: COLORS.primary }}>clients</Highlight> to achieve
          </div>
        </AnimatedHeading>

        <AnimatedTextWithImage
          variants={fadeInText}
          initial="hidden"
          animate="visible"
          transition={{ delay: 0.3 }}
        >
          <img src={heroicon} alt="Icon" />
          <span>their aspirations</span>
        </AnimatedTextWithImage>
      </div>
    </SectionWrapper>
  );
};

export default HeroSection;

